var map = {
	"./B.VENKATESAN.jpg": 74884,
	"./D.Selvakarthi.jpg": 92860,
	"./Dr.K.N.Baluprithiviraj.JPG": 23992,
	"./Dr.K.PRABHU.jpg": 1071,
	"./Dr.M.Raja.jpg": 82607,
	"./Dr.M.SASIREKA.jpg": 83912,
	"./Dr.MadhanMohan.jpg": 83528,
	"./Dr.N.MAHESH.jpg": 32488,
	"./Dr.P.VIDHYALAKSHMI.jpeg": 72703,
	"./Dr.R.MOULEESHUWARAPPRABU.jpg": 46354,
	"./Dr.R.RAJKUMAR.jpg": 10035,
	"./Dr.S.J.SUJI PRASAD.png": 92961,
	"./Dr.S.VIJAYACHITRA.jpg": 19094,
	"./Dr.T.KALAVATHI DEVI.png": 39363,
	"./M.LIZZY NESA BAGYAM.jpg": 61259,
	"./M.THANGATAMILAN.jpg": 25874,
	"./Mr.S.Janarthanan.png": 23407,
	"./N.Indhu.jpg": 28376,
	"./P.REVATHI.jpg": 48153,
	"./R.SURESHKUMAR.jpg": 23828,
	"./S.Anitha.jpg": 65028,
	"./S.JEGAN.jpg": 96820,
	"./T.Keerthanashree.jpg": 99946,
	"./T.MRUNALINI.jpg": 72791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80238;